<template>
  <div class="el-textarea">
    <el-input
      class="el-textarea__input"
      :class="{ 'el-textarea__input--prefix': prefixIcon }"
      type="textarea"
      :autosize="{ minRows, maxRows }"
      resize="none"
      v-model="model"
      :placeholder="placeholder"
    />
    <i
      v-if="prefixIcon"
      class="el-textarea__icon"
      :class="{
        'el-textarea__icon--empty': !cleanModel.length,
        [prefixIcon]: true
      }"
    />
  </div>
</template>

<script>
export default {
  name: 'el-textarea',
  props: {
    value: String,
    minRows: {
      type: Number,
      default: 3,
    },
    maxRows: {
      type: Number,
      default: 6,
    },
    placeholder: String,
    prefixIcon: String,
  },
  data() {
    return {
      model: this.value
    }
  },
  computed: {
    cleanModel() {
      if (!this.model) return ''
      return this.model.trim()
    },
  },
  watch: {
    model(val, oldVal) {
      if (val === oldVal) return
      this.$emit('input', this.cleanModel)
    },
  },
}
</script>

<style>
.el-textarea {
  position: relative;
}

.el-textarea .el-textarea__input.el-textarea__input--prefix textarea {
  padding-left: 40px;
}

.el-textarea .el-textarea__icon {
  position: absolute;
  top: 0;
  left: 0;

  display: grid;
  align-content: center;
  justify-content: center;
  width: 45px;
  height: 40px;
  font-size: 18px;

  color: #404040;
  transition: color .2s ease-in;
}

.el-textarea .el-textarea__icon--empty {
  color: #CCCCCC;
}
</style>
